



































































































helpers = require('../../../helpers.coffee')

view_model =
  components:
    triggerStages: require './trigger_stages.vue'
    stagesMatching: require './stages_matching.vue'
    propertiesMatching: require './properties_matching.vue'

  data: ->
    current_user: Session.current_user
    nectar_setting: if Session.current_user.nectar_setting.id? then Session.current_user.nectar_setting else new NectarSetting()
    nectar_api_key: Session.current_user.nectar_api_key || ''
    nectar_pipeline_types: [{value: 0, text: 'Vendas'}, {value:1, text: 'Qualificação'}]
    nectar_pipeline_type: 0
    nectar_pipelines: []
    nectar_pipelines_options: []
    create_on_add_to_nectar: Session.current_user.nectar_setting.create_on_add
    integration_stages: []
    matching_stages: []
    matching: []
    api_fields: []
    pipelines: []
    update_stages_all_users: false
    selected_pipeline: { stage_query: null }

  watch:
    nectar_api_key: ->
      @loadPipelines()

  methods:
    copy: ->
      navigator.clipboard.writeText(@webhook_url)
        .then =>
          alertify.success(@$t('general.actions.copied'))
        .catch =>
          alertify.error(@$t('general.feedback.actionNotAllowed'))

    setPipeline: ->
      nectar_setting = @nectar_setting
      selectedPipeline = (@nectar_pipelines.find (pipeline) -> pipeline.id == nectar_setting.pipeline_id) || @nectar_pipelines[0]

      if !selectedPipeline then return

      @integration_stages = selectedPipeline.sequencias.map (sequencia) -> { name: sequencia.nome, id: sequencia.sequencia }
      @loadProperties()

    toggleSendTasks: ->
      @nectar_setting.send_tasks = !@nectar_setting.send_tasks

    toggleSyncStatus: ->
      @nectar_setting.sync_status = !@nectar_setting.sync_status

    toggleMarkAddContatsToNectar: ->
      @create_on_add_to_nectar = !@create_on_add_to_nectar

    saveNectar: ->
      @$validator.validateAll({@nectar_api_key}).then (success) =>
        @updateNectarApiKey() if success

    updateNectarApiKey: ->
      Loader.on()
      params = {
        id: Session.current_user.id,
        @nectar_api_key,
        nectar_setting_attributes: {
          id: @nectar_setting.id,
          pipeline_id: @nectar_setting.pipeline_id,
          stage_number: @nectar_setting.stage_number,
          send_tasks: @nectar_setting.send_tasks,
          sync_status: @nectar_setting.sync_status,
          triggers: @nectar_setting.triggers,
          responsible: @nectar_setting.responsible,
          stages_matching: @matching_stages,
          properties_matching: @matching
        }
      }
      new UsersResource().update(@updateNectarApiKeySuccess, @handleApiErrors, params)

    removeNectarApiKey: ->
      @nectar_api_key = null
      @updateNectarApiKey()

    updateNectarApiKeySuccess: (data, response) ->
      Loader.off()
      message_action = if data.user.nectar_api_key then this.$t('general.actions.connectedTo') else this.$t('general.actions.disconnectedTo')
      alertify.success this.$t('integrations.feedback.nectarSuccess')
      Session.signIn(response.body.user)
      @current_user = Session.current_user
      @nectar_api_key = Session.current_user.nectar_api_key
      intercom_event_name = if data.user.nectar_api_key then this.$t('integrations.feedback.connectedToNectar') else this.$t('integrations.feedback.disconnectedToNectar')
      IntercomCtrl.trackEvent(intercom_event_name)

    setStagesNectar: (data) ->
      @nectar_setting.triggers = data

    matchingStagesUpdated: (data) ->
      @matching_stages = data

    matchingUpdated: (data) ->
      @matching = data.filter (field) -> 
        !(field.reev == undefined || field.reev == '')

    updateUsers: (data) ->
      @update_stages_all_users = data.update_all_users

    loadPipelines: ->
      return if @nectar_api_key.length < 40

      delete Vue.http.headers.common['X-User-Email']
      delete Vue.http.headers.common['X-User-Token']

      @$http.get('https://app.nectarcrm.com.br/crm/api/1/pipeline/', { headers: {}, params: { page: -1, type: @nectar_pipeline_type, api_token: @nectar_api_key } })
        .then((response) =>
          @nectar_pipelines = response.body
          @nectar_pipelines_options = response.body.map (pipeline) -> { value: pipeline.id, text: pipeline.nome }
          @setPipeline()        
        )

      Vue.http.headers.common['X-User-Email'] = @current_user.email
      Vue.http.headers.common['X-User-Token'] = @current_user.authentication_token

    loadProperties: ->
      delete Vue.http.headers.common['X-User-Email']
      delete Vue.http.headers.common['X-User-Token']

      @$http.get('https://app.nectarcrm.com.br/crm/api/1/campoPersonalizado/', { headers: {}, params: { page: -1, api_token: @nectar_api_key } })
        .then((response) =>
          @api_fields = response.body
                          .filter((field) -> field.escondido == false)
                          .map((field) -> { name: field.nome, key: field.id, type: field.tipo, required: field.obrigatorio, origin: field.relacionado })
        )

      Vue.http.headers.common['X-User-Email'] = @current_user.email
      Vue.http.headers.common['X-User-Token'] = @current_user.authentication_token

  mounted: ->
    Tooltip.initialize()
    @loadPipelines()
    @nectar_setting.responsible = Session.current_user.email unless @nectar_setting.responsible

  computed:
    webhook_url: ->
      return "#{process.env.API_URL}/webhooks/nectar/import_contacts?token=#{@current_user.authentication_token}"

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/integrations/nectar.vue